import React, { useState } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';

const AssetsFiltersButton = ({ setIsCollapsed, isCollapsed, t }) => {
  return (
    <div className="row">
      <Form.Button
        onClick={(e) => {
          e.preventDefault();
          setIsCollapsed(!isCollapsed);
        }}
        extraClassName="col-g btn btn-info ml-4 mr-4"
        text={`${
          !isCollapsed
            ? t('assets.fields.historics.buttonFilters.showFilters')
            : t('assets.fields.historics.buttonFilters.hideFilters')
        }`}
      />
    </div>
  );
};

export default translate()(AssetsFiltersButton);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFiltersButton.js